<template>
  <fieldset class="input-array">
    <legend>{{ label }}</legend>
    <div v-for="config in inputProps" :key="config.id" class="input-array-input-group">
      <label :for="`duration-${config.id}`">{{ config.label }}</label>
      <input :id="`duration-${config.id}`"
             :value="value[config.id]"
             class="input-array-input"
             :name="`input-array-${config.id}`"
             :type="config.type"
             :min="config.min"
             :max="config.max"
             @input="(ev) => emitDuration(ev, config)">
    </div>
  </fieldset>
</template>

<script>

// TODO:
// needs to be able to handle any input type, and needs better defaults

export default {
  props: {
    label: {
      type: String,
      required: false,
      default: `Duration:`,
    },
    value: {
      type: Object,
      required: true,
    },
    inputProps: {
      type: Array,
      required: true,
    },
  },
  methods: {
    emitDuration(ev, config) {
      if (!this.nullish(config.max)) ev.target.value = Math.min(ev.target.value, config.max);
      if (!this.nullish(config.min)) ev.target.value = Math.max(ev.target.value, config.min);
      this.$emit(`input`, Object.assign(this.value, {
        [config.id]: parseInt(ev.target.value),
      }));
    },
  },
};
</script>

<style lang="scss" scoped>
.input-array {
  legend {
    font-size: 1rem;
    font-weight: 400;
  }

  .input-array-input-group {
    display: inline-block;
    width: 3.2em;
    margin-right: 15px;
    .input-array-input {
      max-width: 100%;
    }
  }
}
</style>
